module.exports = __webpack_public_path__ + "static/media/pedido-encamino-gray.84e6f8a0.svg";